<template>
	<div class="content">
		<div class="content_head">
			<p>
				<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="selectArea">
					<option v-for="(i,index) in $store.state.area" :value="i.areaID">{{i.areaName}}</option>
				</select>
				<select v-model="selectShopID" @change="pageIndex=1;getData()"
					v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType<=1">
					<option v-for="i in  Shop" :value="i.ShopID">{{i.ShopName}}</option>
				</select>

				<input type="text" @keypress.enter="pageIndex=1;getData()" placeholder="请输入查询日期(格式:2021-01-01)"
					class="search" v-model="searchText" />
				<button type="button" class="button " @click="pageIndex=1;getData()" title="点击进行查找">查找</button>
				<button type="button" class="button add" @click="Edit='add';clear()">+排课</button>
			</p>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>课程名称</th>
						<th>适合年龄</th>
						<th>类别</th>
						<th>课程费用</th>
						<th>开始时间</th>
						<th>结束时间</th>
						<th>人数限制</th>
						<th>课程封面</th>
						<th>上课老师</th>
						<th>修改</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(i,index) in ShopSubjects">
						<td>
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>
							{{i.SubjectTitle}}
						</td>
						<td>
							{{i.AgeRange}}
						</td>
						<td>
							{{i.SubjectName}}
						</td>
						<td>
							{{i.PayMoney | rmb}}
						</td>
						<td>
							{{i.BeginDateTime}}
						</td>
						<td>
							{{i.EndDateTime}}
						</td>
						<td>
							{{i.ChildCount+'人'}}
						<td style="padding: .2rem;">
							<img style="width: 8rem;height: auto;"
								:src="$store.state.baseURL.replace('/api','')+'subjectImg/' +i.Subjectimg" />
						</td>
						<td>
							{{i.UserName}}
						</td>


						<td>
							<button type="button" @click="updateSubject(i)" title="点击修改课程" class="button">修改</button>

						</td>
					</tr>
				</tbody>
			</table>
		</div>


		<div class="booksMangement" v-show="Edit!=''">
			<div v-show="Edit!=''">

				<div>
					<span class="red">*</span>课程类别:
				</div>
				<div>
					<select v-model="ShopSubject.SubjectID">
						<option v-for="(i,index) in $store.state.Subjects" :value="i.SubjectID">
							{{i.SubjectName+' '+i.SubjectDesc}}
						</option>

					</select>
				</div>
				<div>
					<span class="red">*</span>课程名称:
				</div>
				<div>
					<input type="text" v-model="ShopSubject.SubjectTitle" placeholder="请输入课程标题" required="required" />
					<span class="err">{{ ShopSubject.SubjectTitle.trim()!=''?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>适合年龄:
				</div>
				<div>
					<input type="text" v-model="ShopSubject.AgeRange" placeholder="课程适合年龄" required="required" />
					<span class="err">{{ ShopSubject.AgeRange.trim()!=''?' ':'×'}}</span>
				</div>


				<div>
					<span class="red">*</span>开始日期:
				</div>
				<div>

					<input type="text" v-model="searchText" required="required" placeholder="请输入开始时间(格式:2021-01-02)" />

					<span class="err">{{$uil.checkDate(searchText)?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>开始时间:
				</div>
				<div>

					<input type="text" v-model="ShopSubject.BeginDateTime" required="required"
						placeholder="请输入开始时间(格式:HH:MM:SS)" />

					<span class="err">{{$uil.checkTime(ShopSubject.BeginDateTime)?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>课程时长:
				</div>
				<div>
					<input type="text" v-model="ShopSubject.Duration" title="输入课程上课时间(分钟)" />
					<span class="err"> {{ ShopSubject.Duration>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>课程费用:
				</div>
				<div>
					<input type="text" v-model="ShopSubject.PayMoney" title="请输入课程费用" />
					<span class="err"> </span>
				</div>
				<div>
					<span class="red">*</span>人数限制:
				</div>
				<div>
					<input type="text" v-model="ShopSubject.ChildCount" title="请输入课程费用" />
					<span class="err"> {{ ShopSubject.ChildCount>0?' ':'×'}}</span>
				</div>

				<div>
					<span class="red">*</span>上课老师:
				</div>
				<div>
					<select v-model="ShopSubject.TeacherID" :disabled="$store.state.user.UserType>1">
						<option v-for="(i,index) in users" :value="i.UserID">{{i.UserName}}</option>
					</select>
				</div>

				<div>
					<span class="red">*</span>课程描述:
				</div>
				<div>
					<textarea v-model="ShopSubject.SubjectDesc">

					</textarea>
					<span class="err"> {{ ShopSubject.SubjectDesc.trim()!=''?' ':'×'}}</span>
				</div>
				<div>
					<span class="red">*</span>选择文件:
				</div>
				<div>

					<img :src="img" ref='preview' v-show="img!=null && img!='' && checkFile=='' "
						style="width: 10rem;height: auto; margin: 1rem;" />
					<br />
					<button type="button" class="button" @click="selectFile">点击选择图片</button>
					<input type="file" style="display:none;" ref='camear' />
					<span class="err">{{checkFile}}</span>

				</div>



				<div>
				</div>
				<div>

					<button class="button" :class="{'disabled':!checkSubject}" :disabled="!checkSubject"
						@click="edit">{{ ShopSubject.ShopSubjectID==0?'新增':'修改'}}</button>
					&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
					<button class="button" @click="Edit=''">取消</button>
				</div>
			</div>
		</div>

	</div>

</template>

<script>
	import j from './index.js'
	export default j
</script>

<style>
</style>
